<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Cadastrar {{ title }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="name"
            :rules="rulesName"
            :error-messages="formError.name"
            label="Nome"
            @input="formError.name = ''"
          />
          <v-text-field
            v-model="short_name"
            :rules="rulesShortName"
            :error-messages="formError.short_name"
            :counter="20"
            maxlength="20"
            label="Sigla / Abreviatura (opcional)"
            @input="formError.short_name = ''"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar {{ title }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
  },
  props: {
    title: { type: String, default: undefined }
  },
  data: () => ({
    rulesName: [
      value => !!value || 'Preenchimento obrigatório.',
      value => (value && value.length >= 3) || 'Min 3 caracteres'
    ],
    formError: {},
    name: '',
    short_name: ''
  }),
  computed: {
    rulesShortName () {
      if (this.name.length > 20) {
        return ['Nome maior que 20 caracteres, inclua sigla(min 2 e max 20 caracteres)']
      }
      if ((this.short_name.length > 0 && this.short_name.length < 2) || this.short_name.length > 20) {
        return ['sigla deve conter entre 2 e 20 caracteres']
      }
      return []
    }
  },
  methods: {
    validate () {
      return this.$refs.form.validate()
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      const data = {
        name: this.name
      }
      if (this.short_name) {
        data.short_name = this.short_name
        data.slug = this.short_name
      }
      this.$emit('resolve', data)
    }
  }
}
</script>
